import './menu.scss'


export default function Menu({ menuOpen, setMenuOpen }) {

    return (
        <div className={'menu ' + (menuOpen && 'active')}>
            <ul>
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#servicios"> SERVICIOS</a>
                </li>
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#nosotros">¿QUIENES SOMOS?</a>
                </li>
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#instrumental">INSTRUMENTAL</a>
                </li>
                <li onClick={() => setMenuOpen(false)}>
                    <a href="#contacto">CONTACTO</a>
                </li>
            </ul>
        </div>
    )
}